import React from 'react';

/**
 * A custom Skeleton component that mimics MUI's Skeleton API using Tailwind CSS.
 * 
 * @param {Object} props
 * @param {'text' | 'rectangular' | 'rounded' | 'circular'} [props.variant='text'] - The shape of the skeleton
 * @param {'pulse' | 'wave' | false} [props.animation='pulse'] - The animation type
 * @param {string|number} [props.width] - The width of the skeleton
 * @param {string|number} [props.height] - The height of the skeleton
 * @param {string} [props.className] - Additional Tailwind classes
 */
export default function Skeleton({
  variant = 'text',
  animation = 'pulse',
  width,
  height,
  className = '',
  ...props
}) {
  // Determine shape classes based on variant
  let shapeClass = '';
  switch (variant) {
    case 'circular':
      shapeClass = 'rounded-full';
      break;
    case 'rectangular':
      shapeClass = 'rounded-none';
      break;
    case 'rounded':
      shapeClass = 'rounded-xl';
      break;
    case 'text':
    default:
      shapeClass = 'rounded-md';
      break;
  }

  // Determine animation classes
  let animationClass = '';
  if (animation === 'pulse') {
    animationClass = 'animate-pulse';
  } else if (animation === 'wave') {
    // We use a custom wave animation class that we will define in Tailwind or inline
    animationClass = 'relative overflow-hidden before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_2s_infinite] before:bg-gradient-to-r before:from-transparent before:via-white/60 before:to-transparent';
  }

  // Ensure default heights if not specified
  const defaultHeight = variant === 'text' ? 'h-4' : '';
  const defaultWidth = variant === 'text' && !width ? 'w-full' : '';

  // Calculate inline styles for width/height if provided as numbers or exact values
  const style = {
    width: typeof width === 'number' ? `${width}px` : width,
    height: typeof height === 'number' ? `${height}px` : height,
  };

  return (
    <div
      className={`bg-gray-200 ${shapeClass} ${animationClass} ${defaultHeight} ${defaultWidth} ${className}`}
      style={style}
      {...props}
    />
  );
}
